export default __webpack_public_path__ + "static/media/logo_jal_menu.0352261b.svg";